import React from 'react';
import { Container, withStyles, Typography, Grid, Button } from '@material-ui/core';

const styles = (theme) => ({
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    footer: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(6),
    },
});

const ErrorPage = (props) => {
    const { classes } = props
    function refreshPage() {
        window.location.reload(false);
    }

    return (
        <>
            <main>
                {/* Hero unit */}
                <div className={classes.heroContent}>
                    <Container maxWidth="sm">
                        <Typography component="h2" variant="h2" align="center" color="textPrimary" gutterBottom>
                            Something went wrong.
            </Typography>
                        <Typography variant="h5" align="center" color="textSecondary" paragraph>
                            Please try again in 5 minutes or contact system administrator.
            </Typography>
                        <div className={classes.heroButtons}>
                            <Grid container spacing={2} justify="center">
                                <Grid item>
                                    <Button variant="contained" color="primary" onClick={refreshPage}>
                                        Reload page
                                                          </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </div>
            </main>
        </>
    );
}
export default withStyles(styles, { withTheme: true })(ErrorPage);